import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintKittsandNevis: Country = {
    identifier: "SaintKittsandNevis",
    name: "Saint Kitts and Nevis",
    countryCode: "KN",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: true,
    flag: "🇰🇳",
    svgPath: "m 299.12275,414.1094 -0.072,0.046 -0.128,-0.18 -0.206,-0.049 -0.178,-0.106 -0.004,-0.023 0.003,-0.053 0.035,-0.062 0.091,-0.047 0.227,0.145 0.106,0.182 0.099,0.083 0.027,0.064 z m 0.277,0.346 -0.141,0.062 -0.12,-0.084 0.027,-0.203 0.114,-0.006 0.114,0.09 0.006,0.141 z",
}
